<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#FFA726"
      d="M32 14.5c0 .829-.672 1.5-1.5 1.5S29 15.329 29 14.5s.672-1.5 1.5-1.5S32 13.671 32 14.5M19 14.5c0 .829-.672 1.5-1.5 1.5S16 15.329 16 14.5s.672-1.5 1.5-1.5S19 13.671 19 14.5"
    />
    <path
      fill="#558B2F"
      d="M36,29c0,0-3.32-7-12-7c-8.68,0-12,7-12,7c-2,3-4,10.344-4,12s1.343,3,3,3h1h14h2h8c1.657,0,3-1.344,3-3S38,34,36,29z"
    />
    <path
      fill="#BBDEFB"
      d="M27.951,22.533l-0.829,2.074L10.113,43.852C10.395,43.939,10.689,44,11,44h1h14h2l2.266-20.566C29.234,22.859,27.951,22.533,27.951,22.533z"
    />
    <path
      fill="#BBDEFB"
      d="M8,41c0,1.656,1.343,3,3,3h1h14h2l-7.976-21.649C10.113,24.344,8,39.281,8,41z"
    />
    <path
      fill="#64B5F6"
      d="M27.921 38L24.204 27.909 22.699 29.611 28 44 25.79 38z"
    />
    <path fill="#FF9800" d="M24,26c-4,0-4-4-4-4v-4h8v4C28,22,28,26,24,26z" />
    <path
      fill="#FFB74D"
      d="M29 38h-3.21L28 44h1c1.657 0 3-1.344 3-3S30.657 38 29 38zM31 10.68c0-5.878-14-3.827-14 0v4.39c0 3.826 3.133 6.93 7 6.93 3.866 0 7-3.104 7-6.931V10.68z"
    />
    <path
      fill="#424242"
      d="M24,3c-4.86,0-8,4.313-8,8.173V13l2,2v-4l9.2-3l2.8,3v4l2-2v-0.808c0-3.22-0.83-6.804-4.8-7.593L26.4,3H24z"
    />
    <g>
      <path
        fill="#784719"
        d="M26 14c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1S26 13.448 26 14M20 14c0 .552.448 1 1 1s1-.448 1-1-.448-1-1-1S20 13.448 20 14"
      />
    </g>
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "SickIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
